import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { ScanLine } from "lucide-react";
import { wmsApi } from "./wmsApi";
import { WInput } from "./WmsUi";
import WmsPieceCard from "./WmsPieceCard";

export default function WmsScan() {
  const [code, setCode] = useState("");
  const [result, setResult] = useState(null);
  const [flash, setFlash] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, [result]);

  const lookup = async (value) => {
    const c = (value || code).trim();
    if (!c) return;
    try {
      const r = await wmsApi.get("/wms/pieces/lookup", { params: { code: c } });
      setResult(r.data);
      setFlash(true);
      setTimeout(() => setFlash(false), 400);
      setCode("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Codice non trovato");
      setCode("");
    }
  };

  return (
    <div className={`space-y-6 transition-colors ${flash ? "bg-green-100" : ""}`}>
      <div>
        <h1 className="font-['Chivo'] font-black text-3xl tracking-tighter uppercase">Scansiona etichetta</h1>
        <p className="text-zinc-500 mt-1">Pistola barcode o digitazione manuale del codice pezzo — poi INVIO</p>
      </div>
      <div className="max-w-xl">
        <div className="flex items-center gap-3 bg-zinc-950 p-4">
          <ScanLine className="w-8 h-8 text-[#FF4500]" />
          <WInput
            ref={inputRef}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") lookup(); }}
            placeholder="Scansiona o digita il codice..."
            className="!bg-zinc-900 !border-zinc-700 !text-white text-2xl font-mono placeholder:text-zinc-600 h-16"
            data-testid="scan-input"
            autoFocus
          />
        </div>
        <p className="text-xs text-zinc-400 mt-2">Il cursore resta sempre attivo: spara col lettore e il pezzo si apre da solo.</p>
      </div>

      {result && (
        <WmsPieceCard
          data={result}
          onClose={() => setResult(null)}
          onChanged={() => { const pid = result.piece.id; setResult(null); wmsApi.get("/wms/pieces/lookup", { params: { code: pid } }).then((r) => setResult(r.data)).catch(() => {}); }}
        />
      )}
    </div>
  );
}
